import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import crumbs from "./modules/crumbs";
import httpconfig from "./modules/httpconfig";
import lottery from "./modules/lottery";
import shop_car from "./modules/shop_car";

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    crumbs,
    httpconfig,
    lottery,
    shop_car
  },
  getters
});
export default store;
